<script lang="ts" setup>
	defineProps<{
		label: string
		icon: Record<string, string | number>
		labelClass?: ClassContext
	}>()
</script>

<template>
	<div
		class="flex min-h-[54px] w-full flex-wrap items-center justify-between gap-x-2 border border-[#DAF1EB] bg-[#ECF8F5] px-5 py-2 sm:flex-nowrap"
	>
		<div class="flex items-center gap-2">
			<lazy-tools-icon
				:icon="icon.name as string"
				:dir="icon.dir as string"
				:height="(icon?.height as number) || 20"
				:width="(icon?.width as number) || 20"
				:path-class="(icon?.pathClass as string) || 'fill-primary-2 '"
			/>
			<div class="overflow-hidden text-ellipsis whitespace-nowrap" :class="labelClass">
				<span class="text-sm font-medium tracking-wide text-gray-600"> {{ label }}</span>
			</div>
		</div>
		<div class="ml-7 w-full pt-3 sm:ml-0 sm:w-auto sm:pt-0">
			<slot />
		</div>
	</div>
</template>
